export default class AsideCtrl {

	constructor($scope, $http, $timeout, $resource, $location, $cookieStore, MenuConstant, UserInfoConstant, permissionList, permissions,
		$state, $rootScope, $mdDialog, $cookies, GlobalSrv, chatboxServices, GlobalConfig, $interval, adminPanel, reportSrv, $localStorage, $sessionStorage, $translate, FileUploader, SERVICE_URL_CONSTANT, Helpers, LOCAL_ENV_CONSTANT) {
		const config = require('../local.env.json')
		const staticServerurl = config.STATIC_IMAGE_URL
		const langs = {
			es : 'Español',
			en : 'English',
			por: 'Portugues',
		}
		const notGroupAssigned = 'user has not any role assigned'
		const notRoleAssigned = 'user has not any role assigned'

		$scope.STATIC_IMAGE_URL = true
		$scope.picture = ''
		$scope.uploader = ''
		var THIS = $scope

		$scope.lang = $cookies.get('lang') || 'es'
		$scope.languages = []
		config.AVAILABLE_LANG = config.AVAILABLE_LANG || [ 'es' ]

		for (let i in config.AVAILABLE_LANG) {
			$scope.languages.push({
				key  : config.AVAILABLE_LANG[i],
				value: langs[config.AVAILABLE_LANG[i]],
				src  : 'assets/images/flags/' + config.AVAILABLE_LANG[i] + '.png',
			})
		}

		$translate.use($scope.lang)
		$scope.languageHeader = updateLanguageKey($scope.lang, $scope.languages)

		$scope.updateLanguage1 = (key) => {
			$translate.use(key)
			$scope.languageHeader = updateLanguageKey(key, $scope.languages)
		}

		function updateLanguageKey(key, value) {
			for (var i in value) {
				if (value[i].key == key) {
					return value[i]
				}
			}
		}

		$scope.menuClickLang = (e, index) => {
			if (flag) {
				if ($('.box-inner #parent_li_' + index).hasClass('active')) {
					$('.box-inner #parent_li_' + index).removeClass('active')
				} else {
					$('.box-inner #parent_li_' + index).addClass('active')
				}
			}

			flag = true
		}

		let url = {}
		let serverUrl = {}
		let localenv = require('../local.env.json')
		let flag = true

		let NotifyCurrentUser = $cookies.get('currentUser')
		let locationpath = $location.path()

		// var split = split($location).substring(externalUrlFiles[j].lastIndexOf("/") + 1)
		var externalPortfolio = ($location.search().external ? $location.search().external : false)

		function wsdlLogin() {
			const cookieObject = $localStorage.userAuth
			let autoLogin = $location.search().accessLogin

			if (autoLogin) {
				try {
					autoLogin = decodeURIComponent(escape(window.atob(autoLogin)))
					const email = autoLogin

					delete $localStorage.autoLogin
					const param = {
						type : 'autoLogin',
						users: {
							sn       : email,
							givenname: email,
							name     : email,
							mail     : email,
						},
					}

					GlobalSrv.getUserInfoMetta.POST(param).$promise.then((response) => {
						if (response.status == 1) {
							const data = Helpers.getUserStored(response.data)

							$localStorage.userLogin = data
							$localStorage.userAuth = response.data
							$localStorage.logintime = Date.now()
							window.location = LOCAL_ENV_CONSTANT.HOMEPAGE
						} else {
							delete $localStorage.userLogin
							delete $localStorage.userAuth
						}
					}).catch(() => {
						window.location = url + '?returnTo=' + serverUrl
					})
				} catch (e) {
					delete $localStorage.userLogin
					delete $localStorage.userAuth
					window.location = LOCAL_ENV_CONSTANT.HOMEPAGE
				}
			} else if (typeof cookieObject === 'undefined') {
				$state.go('login')
			} else {
				setResponseData(Helpers.getUserStored(cookieObject))
			}
		}

		function adalFunctionCallback() {
			var searchObject = $location.search().idUserToken

			if (typeof searchObject !== 'undefined') {
				var temp = JSON.parse(decodeURIComponent(atob(searchObject).split('').map((c) => {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
				}).join('')))

				GlobalSrv.getUserInfoMetta.POST(temp).$promise.then((response) => {
					const data = response.data

					if (response.status == 1) {
						$localStorage.userLogin = data
						$location.search('idUserToken', null)

						if (typeof data === 'undefined') {
							window.location = url + '?returnTo=' + serverUrl + 'app/welcomeHome'
						} else {
							setResponseData(data)
						}
					} else {
						delete $localStorage.userLogin
					}
				}).catch(() => {
					window.location = url
				})
			} else {
				var cookieObject = $localStorage.userLogin

				if (typeof cookieObject === 'undefined') {
					window.location = url + '?returnTo=' + serverUrl + 'app/welcomeHome'
				} else {
					setResponseData(cookieObject)
				}
			}
		}

		function casAdalFunctionCallback() {
			$.ajax({
				dataType: 'jsonp',
				data    : 'returnTo=' + serverUrl,
				jsonp   : 'callback',
				url     : url,
				cache   : true,
				async   : true,
				headers : {
					'Access-Control-Allow-Origin' : '*',
					'Access-Control-Allow-Methods': 'GET,OPTIONS',
					'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
					'Content-Type'                : 'text/plain',
					'Accept-Language'             : 'en-US',
				},
				xhrFields: {
					withCredentials: true,
				},
				crossDomain: true,
				success    : function (response) {
					var temp = JSON.parse(decodeURIComponent(atob(response).split('').map((c) => {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
					}).join('')))

					response = temp
					setResponseData(response)
				},
				error: (xhr, ajaxOptions, thrownError) => {
					window.location = url
					console.log(thrownError)
				},
			})
		}

		function setResponseData(cookieObject) {
			var response = cookieObject

			$scope.admin = response.user
			// $cookies.put('ESTSAUTH_INTIAL',false)
			UserInfoConstant[0].details.push(response)
			setCookiesValues(response)
			permissions.setPermissions(response.user.permissions[0])
			$scope.idUser = response.user.id
			$timeout(function () {
				notificationUserInbox(response)
				countNotificationsUserInboxNoRead()
			}, 10000)
			var RoleId = 0

			if (!$cookies.get('hasRoleId')) {
				RoleId = response.user.role[0] ? response.user.role[0].role_id : 0
			} else {
				RoleId = $cookies.get('hasRoleId')
			}

			let header = { RoleId: RoleId }

			GlobalSrv.getChangeRole.get(header).$promise.then((dataReturn) => {
				permissions.setPermissions(dataReturn.user.permissions[0])
				response.user.permissions[0] = dataReturn.user.permissions[0]
				response.user.url = ''
				// console.log("la url del usuario es: ", response.user.url);
				response.user.url = dataReturn.user.url
				UserInfoConstant[0].details[0].user['url'] = []
				UserInfoConstant[0].details[0].user['url'] = dataReturn.user.url
				$timeout(function () {
					$scope.subitems = MenuConstant[0].menu
					$scope.roles = [ { name: 'Roles', items: response.user.role } ]
					$rootScope.$emit('CallMyMethodRoles', $scope.roles)
					getAsideMenu()
				}, 200)

				UserInfoConstant[0].details[0].user['url'].push('/app')

				if (response.user.id === 1) {
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios/crear')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/roles')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/roles/crear')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/grupos')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/grupos/crear')
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios/edit')
				}

				// let permission = next.$$state.permission;
				$timeout(function () {
					const urls = processUrl($location.path())

					if (RoleId == 15) {
						var flag = false

						for (var i in MenuConstant[0]['menu']) {
							if (MenuConstant[0]['menu'][i][0].title == 'Admin-Panel') {
								delete MenuConstant[0]['menu'][i]
								flag = true
							}
						}
						// if (flag == false) {
						MenuConstant[0]['menu'][MenuConstant[0]['menu'].length] = (adminPanel)
						// }

						UserInfoConstant[0].details[0].user['url'].push('//panel-integracion/integracion')
						UserInfoConstant[0].details[0].user['url'].push('/app/panel-integracion/integracion')
					} else {
						// MenuConstant[0]['menu']={};
						for (var i in MenuConstant[0]['menu']) {
							if (MenuConstant[0]['menu'][i][0].title == 'Admin-Panel') {
								delete MenuConstant[0]['menu'][i]
							}
						}
					}

					if (UserInfoConstant[0].details[0].user['url'].indexOf(urls.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(urls.str3) > -1) {
						// $state.go('app.welcomeHome');
					} else {
						if (urls.string != '/app/welcomeHome') {
							$state.go('app.unauthorized')
						}
						// $location.path('/app/unauthorized')
					}
				}, 100)
			}, (dataReturn) => {
				console.log(dataReturn)
			})
		}

		if (localenv.USER_API_URL && !externalPortfolio) {
			const protocol = $location.protocol()

			url = localenv.USER_API_URL + '/api/user-api'
			serverUrl = localenv.SERVER_NAME

			if (protocol == 'http') {
				$cookies.put('ESTSAUTH_INTIAL', 'true')
			}

			const ESTSAUTH = $cookies.get('ESTSAUTH_INTIAL')

			const uploader = $scope.uploader = new FileUploader({
				url       : SERVICE_URL_CONSTANT.rosario + '/perfil/setProfileImage',
				autoUpload: true,
			})

			uploader.filters.push({
				name: 'imageFilter',
				fn  : function (item) {
					var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|'

					return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1
				},
			})

			uploader.onSuccessItem = function (fileItem, response, status, headers) {
				console.info('onSuccessItem', fileItem, response, status, headers)
			}

			uploader.onErrorItem = function (fileItem, response, status, headers) {
				console.info('onErrorItem', fileItem, response, status, headers)
			}

			uploader.onCompleteItem = function (fileItem, response, status, headers) {
				console.info('onCompleteItem', fileItem, response, status, headers)
				THIS.STATIC_IMAGE_URL = true
				THIS.picture = response.data + '?' + Math.random()
				THIS.STATIC_IMAGE_URL_UPLOAD = true
				const cookiesUser = $cookies.getObject('currentUser')

				if (cookiesUser) {
					cookiesUser.pictureExtension = response.data.replace(staticServerurl + '/profilepicture/', '')
					$cookies.putObject('currentUser', cookiesUser)
				}
			}

			uploader.onBeforeUploadItem = function (item) {
				item.formData = []
				item.formData.push({ id: THIS.rut })
				THIS.STATIC_IMAGE_URL_UPLOAD = true
			}

			/**************************************/

			if ([ 'adal', 'gsuite' ].indexOf(localenv.loginType) >= 0) {
				adalFunctionCallback()
			} else if (localenv.loginType == 'web') {
				wsdlLogin()
			} else {
				casAdalFunctionCallback()
			}
		} else {
			let response = `{
            "user": {
              "name": "Invitado",
              "email": "Invitado",
              "id": 34,
              "permissions": [
              {
                "filtertableedit": true,
                "campuses-association": true,
                "create-academic-programming": true,
                "update-academic-programming": true,
                "campus-academicperiod-shift-academicprogramming": true,
                "update-campus-period-shift": true,
                "create-classroom-association": true,
                "career-pensum-insert": true,
                "course-pensum-insert": true,
                "disable-simulation": true,
                "disable-multiple-simulations": true
              }
              ],
              "central": 1
            }
          }`

			response = JSON.parse(response)
			$scope.admin = response.user
			UserInfoConstant[0].details.push(response)
			permissions.setPermissions(response.user.permissions[0])
			$scope.subitems = MenuConstant[0].menu
			getAsideMenu()
		}

		$scope.menuClick = menuClick
		$scope.superMenu = superMenu
		$scope.menuLogout = menuLogout
		$scope.toogleAccountClass = toogleAccountClass
		$scope.openAside = openAside
		$scope.callFunction = callFunction
		$scope.showModalCreateWorkplan = showModalCreateWorkplan
		// $scope.roleClick = roleClick
		$scope.validateRoleSelected = validateRoleSelected
		$scope.validateRoleSelectedMenu = validateRoleSelectedMenu
		$scope.validateSubModule = validateSubModule
		$scope.notificationUserInbox = notificationUserInbox
		$scope.workPlanGeneral = notificationUserInbox
		$scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead
		$rootScope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead
		$scope.validateIfWorkPlanActive = validateIfWorkPlanActive

		$scope.onUserPictureError = function (callback) {
			$scope.picture = $scope.notPicture
			let cookiesUser = $cookies.getObject('currentUser')

			if (cookiesUser) {
				cookiesUser.pictureExtension = null
				$cookies.putObject('currentUser', cookiesUser)
			}

			if ($scope.rut) {
				GlobalSrv.getUserImage.get({ identification: $scope.rut }).$promise.then((response) => {
					$scope.pictureRosario = response.profilePicture + '?1=' + $scope.mathRandom

					if (cookiesUser) {
						cookiesUser.pictureRosario = $scope.pictureRosario
						$cookies.putObject('currentUser', cookiesUser)
					}

					callback()
				})
			} else {
				callback()
			}
		}

		let getCurrentUser = $interval(() => {
			let cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false

			if (cookiesUser) {
				// var currentUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
				var currentUser = JSON.parse($cookies.get('currentUser'))

				workPlanGeneral()
				$scope.showWorkplanMenuOption = !!(currentUser && currentUser.isWorkPlanActive)
				$scope.rut = (currentUser && currentUser.dsIdentification) ? currentUser.dsIdentification : ''
				$scope.mathRandom = Math.random()
				$scope.notPicture = require('./images/unknown.png')

				if (currentUser.pictureExtension) {
					$scope.picture = staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + $scope.mathRandom
				} else if (cookiesUser.pictureRosario) {
					$scope.picture = cookiesUser.pictureRosario
				}

				$interval.cancel(getCurrentUser)

				$timeout(() => {
					var intialLogin = $cookies.get('isIntialLoginResponse')
					var rid = 0

					rid = $cookies.get('hasRoleId')

					if (intialLogin != rid) {
						$cookies.put('isIntialLoginResponse', rid)
						var param = {
							idRole   : rid,
							idUser   : currentUser.id,
							teacherId: currentUser.teacherId,
						}

						$.ajax({
							url    : localenv.SERVICE_URL_CONSTANT.rosario + '/report/getTimestamp',
							global : false,
							type   : 'GET',
							data   : $.param(param),
							async  : true, //blocks window close
							success: () => {
								console.log('report is generated')
							},
						})

						if (currentUser.teacherId)
							GlobalSrv.jobForeachPureApi.execute({ teacherId: currentUser.teacherId })
					}
				}, 800)
			}
		}, 500)

		function menuClick(e, index) {
			if (flag) {
				if ($('.box-inner #parent_li_' + index).hasClass('active') || $scope.subitems[index][0].url) {
					$('.box-inner #parent_li_' + index).removeClass('active')
				} else {
					$('.box-inner #parent_li_' + index).addClass('active')
				}
			}

			flag = true
		}

		function superMenu(element, index) {
			if ($('#super_menu_li_' + index).hasClass('active')) {
				$('#super_menu_li_' + index).removeClass('active')
			} else {
				$('#super_menu_li_' + index).addClass('active')
			}

			flag = false
		}

		function super_menu_language(element, index) {
			if ($('#super_menu_li_lang_' + index).hasClass('active')) {
				$('#super_menu_li_lang_' + index).removeClass('active')
			} else {
				$('#super_menu_li_lang_' + index).addClass('active')
			}

			flag = false
		}

		function menuLogout(e, index) {
			if (config.loginType === 'web') {
				removeCookies()
				window.location.href = '/login'
			} else {
				const cooky = $cookies.get('currentUser')
				const login = JSON.parse(cooky)
				
				let post = {
					userId: login.id,
					onLine: 0,
				}

				removeCookies()
				chatboxServices.updateChatStatus
					.post(post).$promise
					.then(() => {
						window.location = url + '/logout?id=' + login.id
					}).catch((error) => {
						console.error(error)
					})
			}
		}

		function toogleAccountClass() {
			$('#nav,#account').toggleClass('hide')
		}

		function openAside() {
			$scope.folded = !$scope.folded

			if (!$scope.folded) {
				$('#menubaritem').addClass('menu-right')
				$('#menubaritem').removeClass('menu-left')
				$('#menubaritem2').addClass('menu-right-2')
				$('#menubaritem2').removeClass('menu-left-2')
			} else {
				$('#menubaritem').removeClass('menu-right')
				$('#menubaritem').addClass('menu-left')
				$('#menubaritem2').removeClass('menu-right-2')
				$('#menubaritem2').addClass('menu-left-2')
			}
		}

		function openAsideFullscreen() {
			$scope.fullyFolded = !$scope.fullyFolded

			if ($scope.fullyFolded) {
				$('#menubaritem1').addClass('menu-right')
				$('#menubaritem1').removeClass('menu-left')
			} else {
				$('#menubaritem1').removeClass('menu-right')
				$('#menubaritem1').addClass('menu-left')
			}
		}

		function callFunction(name) {
			if (angular.isFunction($scope[name])) {
				$scope[name]()
			}
		}

		function showModalCreateWorkplan() {
			$mdDialog.show({
				controller         : 'workPlanCreateModalCtrl',
				template           : require('./layout/modal-create-workplan.html'),
				clickOutsideToClose: true,
				fullscreen         : $scope.customFullscreen, // Only for -xs, -sm breakpoints.
			})
		}

		$scope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => {
			$timeout(() => {
				var string = $location.path()
				var str3 = string.replace(/[0-9]/g, '')
				var str2 = string.replace(/[^\d.]/g, '')

				if (str2 > 999) {
					string = string.replace(/\//g, '')
				}

				if (str2) {
					string = string.replace(str2, '*')
				}

				console.log('El valor de la url es : ', str3)

				// let urlParse = $state.current.url.split('?') UNUSED VARIABLE
				if (UserInfoConstant[0].details[0].user['url'].indexOf(string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(str3) > -1) {
					// $state.go('app.unauthorized');
				} else {
					// $location.path('/app/unauthorized')
				}
			}, 200)
		})

		// $scope.folded=true;
		$rootScope.$on('CallMyMethod', () => {
			$scope.openAside()
		})

		$rootScope.$on('CallMyMethodfullscreen', () => {
			openAsideFullscreen()
		})

		$rootScope.$on('profileimagechange', () => {
			alert(1)
			$scope.mathRandom = Math.random()
		})

		$rootScope.$on('rootScope:ReportEmit', function(event) {
			getAsideMenu()
		})
		function getAsideMenu() {
			for (let item in $scope.subitems) {
				let showifSubitem = validateRoleSelectedMenu($scope.subitems[item])

				$scope.subitems[item].showif = showifSubitem

				if (showifSubitem) {
					for (let items in $scope.subitems[item][0].subMenu) {
						let showif = validateRoleSelected($scope.subitems[item][0].subMenu[items].rolesAllowed, $scope.subitems[item][0].subMenu[items])
						
						$scope.subitems[item][0].subMenu[items].showif = showif
					}
					
					if ($scope.subitems[item][0].subMenu && !$scope.subitems[item][0].subMenu.some((item) => {
						return item.showif
					})) {
						$scope.subitems[item].showif = false
					}
				}
			}
		}

		function validateRoleSelected(rolSelected, subMenu) {
			if (!rolSelected) {
				let show = false

				if (!subMenu.superMenu) {
					const url = subMenu.url
					
					const ref = $state.href(url)
					
					if (!ref) return false

					const processedUrl = processUrl(ref)
					
					if (UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.str3) > -1) {
						show = true
					}
 
					return show
				}

				for (var i = 0; i < subMenu.superMenu.length; i++) {
					const url = subMenu.superMenu[i].url
					
					const ref = $state.href(url)
					
					if (!ref) continue

					const processedUrl = processUrl(ref)

					if (UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.str3) > -1) {
						show = true
						subMenu.superMenu.showIf = true
					} else {
						subMenu.superMenu.showIf = false
					}
				}

				return show
			} else {
				return rolSelected.indexOf(parseInt($cookies.get('hasRoleId'))) > -1
			}
		}

		function processUrl(url) {
			var str3 = url.replace(/[0-9]/g, '')
			var str2 = url.replace(/[^\d.]/g, '')

			if (str2 > 999) {
				url = url.replace(/\//g, '')
			}

			if (str2) {
				url = url.replace(str2, '*')
			}

			if (str3 == '/app/evaluations/teacherAssessment/') {
				if (str2) {
					str3 += '*'
				}
			}

			if (url.length > 1 && url.endsWith('/')) {
				url = url.slice(0, url.length - 1)
			}

			return {
				string: url,
				str2,
				str3,
			}
		}

		function validateTeacherTypeSelected(option) {
			var user = $cookies.getObject('currentUser')

			if (user) {
				if (user.teacherId) {
					if (option == GlobalConfig.menuModulesId.Portfolio)
						return user.isPortfolio

					if (option == GlobalConfig.menuModulesId.Profile)
						return user.isProfile

					if (option == GlobalConfig.menuModulesId.StrategicTracking) {
						return user.isWorkPlanActive
					}
				}
			}

			return true
		}

		function validateRoleSelectedMenu(item) {
			if (item && item[0]) {
				if (validateTeacherTypeSelected(item[0].moduleId)) {
					if (typeof item[0].subMenu !== 'undefined') {
						let hasSubMenu = false

						for (var i = 0; i < item[0].subMenu.length; i++) {
							var rolSelected = item[0].subMenu[i].rolesAllowed

							if (!rolSelected) {
								hasSubMenu = true
								i = item[0].subMenu.length
							} else { 
								if (rolSelected.indexOf(parseInt($cookies.get('hasRoleId'))) > -1) {
									hasSubMenu = true
									i = item[0].subMenu.length
								}
							}
						}

						return hasSubMenu
					} else {
						return true
					}
				}
			}
		}

		function validateSubModule(menuRoleId, stageId) {
			if (!menuRoleId || !stageId) {
				return true
			} else {
				//si el item del panel izquierdo es la opcion del index
				if (menuRoleId && menuRoleId[0] == GlobalConfig.modules.indexOption) {
					let isApproved = JSON.parse($cookies.get('isApproved'))

					if (isApproved == 1 || isApproved == 2) {
						return false
					} else {
						return true
					}
				}

				let user = JSON.parse($cookies.get('currentUser'))
				let isReproved = JSON.parse($cookies.get('isReproved'))

				return searchValue(JSON.parse($cookies.get('subModuleId')), menuRoleId[0],
					JSON.parse($cookies.get('stageId')), stageId[0],
					user.isFeedback, user.isFeedbackPlanning, isReproved)
			}
		}

		function searchValue(arraySubmodule, submoduleId, arrayStage, stageId, feedback, feedbackPlanning, isReproved) {
			var result = false

			// validar que en la cookie tenga esa etapa y ademas esta entre las fechas acordes
			for (var i = 0, len = arrayStage.length; i < len; i++) {
				if (arrayStage[i].stageId == stageId && compareDates(arrayStage[i].startDate, arrayStage[i].endDate)) {
					if (stageId == GlobalConfig.workplanIdStages.planning) {
						// validar que este retroalimentado
						result = ((feedback == 0 ? feedback == 0 : (feedback == 1 && feedbackPlanning == 0)) && !isReproved)
						break
					} else {
						result = true
						break
					}
				}
			}

			if (result) {
				// si el id de submodulo es ejecucion mostrarlo ya que se encuentra en la etapa deseada
				if (submoduleId == GlobalConfig.modules.execution) {
					// Si el plan no esta aprobado no se muestra la opcion de ejecuci�n
					let isApproved = JSON.parse($cookies.get('isApproved'))

					if (isApproved == 1 || isApproved == 2) {
						return true
					} else {
						return false
					}
				}

				result = false

				for (var i = 0, len = arraySubmodule.length; i < len; i++) {
					if (arraySubmodule[i].submoduleId == submoduleId) {
						result = true
						break
					}
				}
			}

			return result
		}

		function compareDates(startDate, endDate) {
			var now = moment({ hour: 0, minute: 0, second: 0, millisecond: 0 })
			var start = moment(startDate)
			var end = moment(endDate)

			if (now.isBefore(end) && now.isAfter(start) || (now.isSame(start) || now.isSame(end))) {
				return true
			} else {
				return false
			}
		}

		function validateIfWorkPlanActive(forWorkplanActiveMenu) {
			if (forWorkplanActiveMenu) {
				return $scope.showWorkplanMenuOption
			} else {
				return true
			}
		}

		function setCookiesValues(response) {
			let serviceResponse = angular.copy(response)

			if (!$cookies.get('currentUser')) {
				let header = { userId: response.user.id }

				GlobalSrv.getUserInfo.get(header).$promise.then((dataReturn) => {
					serviceResponse.user.teacherId = dataReturn.teacherId
					serviceResponse.user.workplanId = dataReturn.workplanId
					serviceResponse.user.isWorkPlanActive = dataReturn.isWorkPlanActive
					serviceResponse.user.dsIdentification = dataReturn.dsIdentification
					serviceResponse.user.dsFullname = dataReturn.dsFullname
					serviceResponse.user.isPortfolio = dataReturn.isPortfolio
					serviceResponse.user.isProfile = dataReturn.isProfile

					$scope.isProfile = serviceResponse.user.isProfile

					if (serviceResponse.user.isWorkPlanActive) {
						$scope.showWorkplanMenuOption = true
					} else {
						$scope.showWorkplanMenuOption = false
					}

					delete serviceResponse.user.permissions
					delete serviceResponse.user.url
					serviceResponse.user.isFeedback = dataReturn.isFeedback
					serviceResponse.user.isFeedbackPlanning = dataReturn.isFeedbackPlanning
					$cookies.putObject('currentUser', serviceResponse.user)
					$cookies.putObject('subModuleId', dataReturn.summodules)
					$cookies.putObject('stageId', dataReturn.stages)
					$cookies.putObject('reviewers', dataReturn.reviewers)
					$cookies.put('isReproved', dataReturn.isReproved)
					$cookies.put('isApproved', dataReturn.isApproved)
					$scope.rut = dataReturn.dsIdentification
					$scope.mathRandom = Math.random()
					$scope.picture = staticServerurl + '/profilepicture/' + serviceResponse.user.pictureExtension + '?1=' + $scope.mathRandom
				})
			}

			$cookies.put('adminName', $scope.admin.name)

			if (!$cookies.get('hasRoleId')) {
				if (!response.user.role[0]) {
					return
				}

				$cookies.put('hasRoleId', response.user.role[0].role_id)
				$cookies.put('roleName', response.user.role[0].role_name)
				$scope.rolActive = response.user.role[0].role_name
			} else {
				let idRol = $cookies.get('hasRoleId')

				for (var i = 0; i < response.user.role.length; i++) {
					if (response.user.role[i].role_id == idRol) {
						$scope.rolActive = response.user.role[i].role_name

						i = response.user.role.length
					}
				}
			}

			window.Intercom('boot', {
				api_base  : 'https://api-iam.intercom.io',
				app_id    : 'rio5bzun',
				name      : response.user.name,
				email     : response.user.email,
				group_id  : passGroupIds2Intercom(response.user),
				group_name: passGroupNames2Intercom(response.user),
				rol_id  		: passRoleIds2Intercom(response.user),
				rol_name 	: passRoleNames2Intercom(response.user),
				subdomain : window.location.host.split('.')[0],
				created_at: new Date().toISOString(),
			})
		}

		function notificationUserInbox(response) {
			let header = { userId: response.user.id }

			GlobalSrv.getScheduledInbox.get(header).$promise
				.then(() => GlobalSrv.getUserInbox.get(header).$promise)
				.then((dataReturn) => {
					if (dataReturn.status) {
						console.log(dataReturn)
						$scope.notificationUserInbox = dataReturn.data
					} else {
						$scope.notificationUserInbox = []
					}

					$rootScope.$emit('CallSetNotifications', $scope.notificationUserInbox)
				})
				.catch((error) => {
					console.log(error)
				})			
		}

		function workPlanGeneral() {
			const listUser = JSON.parse($cookies.get('currentUser'))
			let post = {
				teacherId : listUser.teacherId,
				workplanId: listUser.workplanId,
			}

			if (post.teacherId != undefined && post.teacherId != null && $sessionStorage.workPlanGeneralList == undefined) {
				GlobalSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						$sessionStorage.workPlanGeneralList = dataReturn.data
					} else {
						console.log('Comunications problem with the server')
					}
				}, (data) => {
					console.log(data)
				})
			}
		}

		function countNotificationsUserInboxNoRead() {
			let header = { userId: $scope.idUser }

			GlobalSrv.getCountNotificationsUserInboxNoRead.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status == true) {
					$scope.countNotificationsUserInboxNoRead = dataReturn.data[0].countNotificationsUserInboxNoRead
				} else {
					$scope.countNotificationsUserInboxNoRead = ''
				}

				$rootScope.$emit('CallSetCountNotificationsUserInboxNoRead', $scope.countNotificationsUserInboxNoRead)
			}, (dataReturn) => {
				console.log(dataReturn)
			})
		}

		function removeCookies() {
			$cookies.put('hasDemand', '')
			$cookies.remove('isAdmin')
			$cookies.remove('hasType')
			$cookies.remove('hasRoleId')
			$cookies.remove('currentUser')
			$cookies.remove('subModuleId')
			$cookies.remove('stageId')
			$cookies.remove('reviewers')
			$cookies.remove('isReproved')
			$cookies.remove('adminName')
			$cookies.remove('roleName')
			$cookies.remove('isIntialLogin')
			$cookies.remove('isIntialLoginResponse')
			delete $sessionStorage.workPlanGeneralList
			delete $localStorage.userLogin
			delete $localStorage.userAuth
		}

		function passGroupNames2Intercom(userInfo) {
			let userGroups = ''

			if (userInfo.groups.length) {
				for (const group of userInfo.groups) {
					userGroups += `${group.groupname}, `
				}

				return userGroups
			}

			return notGroupAssigned
		}

		function passRoleNames2Intercom(userInfo) {
			let userRoles = ''

			if (userInfo.role.length) {
				for (const role of userInfo.role) {
					userRoles += `${role.role_name}, `
				}

				return userRoles
			}

			return notRoleAssigned
		}

		function passGroupIds2Intercom(userInfo) {
			let userGroupIds = ''

			if (userInfo.groups.length) {
				for (const role of userInfo.groups) {
					userGroupIds += `${role.groupid}, `
				}

				return userGroupIds
			}

			return notGroupAssigned
		}

		function passRoleIds2Intercom(userInfo) {
			let userRoleIds = ''

			if (userInfo.role.length) {
				for (const role of userInfo.role) {
					userRoleIds += `${role.role_id}, `
				}

				return userRoleIds
			}

			return notRoleAssigned
		}
	}

}

AsideCtrl.$inject = [ '$scope', '$http', '$timeout', '$resource', '$location', '$cookieStore', 'MenuConstant',
	'UserInfoConstant', 'permissionList', 'permissions', '$state', '$rootScope', '$mdDialog', '$cookies', 'GlobalSrv',
	'chatboxServices', 'GlobalConfig', '$interval', 'adminPanel', 'reportSrv', '$localStorage', '$sessionStorage', '$translate', 'FileUploader', 'SERVICE_URL_CONSTANT', 'Helpers', 'LOCAL_ENV_CONSTANT' ]



// WEBPACK FOOTER //
// ./src/asideCtrl.js